import { iconNavDots } from '@bsds-lib-component/icons/icons';
import { BsdsIcon } from '@bsds-lib-component/react';
import React from 'react';

import Tooltip from '../../tooltip/Tooltip';
import TableMenuPortal from './TableMenuPortal';
import {
  TABLE_MENU_ITEM_BUTTON_CLASS,
  TABLE_MENU_TRIGGER_BUTTON_CLASS,
} from './tableMenuUtils';

type TableHeaderBulkActionsMenuProps = {
  isOpen: boolean;
  menuButtonId: string;
  menuRef: React.RefObject<HTMLDivElement | null>;
  menuButtonRef: React.RefObject<HTMLButtonElement | null>;
  actionButtonRef: React.RefObject<HTMLButtonElement | null>;
  actionLabel: string;
  actionDisabled?: boolean;
  onToggle: (event: React.MouseEvent) => void;
  onMenuKeyDown: (event: React.KeyboardEvent) => void;
  onAction: (event: React.MouseEvent) => void;
  onActionKeyDown: (event: React.KeyboardEvent) => void;
  triggerButtonClassName?: string;
  wrapTriggerWithTooltip?: boolean;
};

const TableHeaderBulkActionsMenu: React.FC<TableHeaderBulkActionsMenuProps> = ({
  isOpen,
  menuButtonId,
  menuRef,
  menuButtonRef,
  actionButtonRef,
  actionLabel,
  actionDisabled = false,
  onToggle,
  onMenuKeyDown,
  onAction,
  onActionKeyDown,
  triggerButtonClassName,
  wrapTriggerWithTooltip = true,
}) => {
  const triggerButton = (
    <button
      type="button"
      id={menuButtonId}
      ref={menuButtonRef}
      onClick={onToggle}
      onKeyDown={onMenuKeyDown}
      className={triggerButtonClassName ?? TABLE_MENU_TRIGGER_BUTTON_CLASS}
      aria-label="Menu de ações"
      aria-expanded={isOpen}
      aria-haspopup="menu"
      aria-controls={`${menuButtonId}-menu`}
      aria-pressed={isOpen}
    >
      <BsdsIcon icon={iconNavDots} className="w-3 h-3 text-gray-600" aria-hidden="true" />
    </button>
  );

  return (
    <>
      {wrapTriggerWithTooltip ? (
        <Tooltip label="Menu de ações">{triggerButton}</Tooltip>
      ) : triggerButton}
      <TableMenuPortal
        isOpen={isOpen}
        anchorRef={menuButtonRef}
        menuRef={menuRef}
        align="left"
        id={`${menuButtonId}-menu`}
        aria-labelledby={menuButtonId}
        aria-label="Ações da tabela"
        className="w-40"
      >
        <button
          type="button"
          ref={actionButtonRef}
          onClick={onAction}
          onKeyDown={onActionKeyDown}
          disabled={actionDisabled}
          role="menuitem"
          aria-disabled={actionDisabled}
          className={`${TABLE_MENU_ITEM_BUTTON_CLASS} ${actionDisabled
            ? 'text-gray-400 cursor-not-allowed opacity-50'
            : ''
          }`}
        >
          {actionLabel}
        </button>
      </TableMenuPortal>
    </>
  );
};

export default TableHeaderBulkActionsMenu;
